import React from 'react';
import { PerformanceContextProvider } from '../../store/contexts/performance';
import { Improvements } from './Improvements';
import { Metrics } from './Metrics';

import { ContentWrapper } from '../../styles/sideContainerStyles';

export function Performance(): JSX.Element {
  return (
    <PerformanceContextProvider>
      <ContentWrapper>
        <Metrics />
        <Improvements />
      </ContentWrapper>
    </PerformanceContextProvider>
  );
}
